<template>
  <section class="container">
    <div class="header">
      <span class="header__question">
        您遇到了什么问题？
      </span>
      <span class="header__service">
        请选择您问题的类型
      </span>
    </div>
    <div class="content">
      <div class="whiteLine"></div>
      <van-cell-group>
        <van-collapse v-model="activeNames">
          <van-collapse-item v-for="(items,index) in menuList" :key="index" :title="items.text">
            {{items.content}}
          </van-collapse-item>
        </van-collapse>
      </van-cell-group>
    </div>
    <div class="service">
      <!-- <a :href="`tel:${phone}`">客服:{{this.phone}} </a> -->
    </div>
  </section>
</template>

<script>
import { Collapse, CollapseItem, CellGroup } from 'vant'
import config from '@/config/index'
export default {
  name: 'InvoiceHelp',
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [CellGroup.name]: CellGroup
  },
  data () {
    return {
      phone: this.$enumObject.providerConfig[config.projectName].servicePhone,
      activeNames: ['1'],
      menuList: [
        {
          text: '开票后在哪里找到发票？',
          content: '电子发票开具提交后，请您耐心等待，稍后会将电子发票推送到您填写的邮箱。'
        },
        {
          text: '如何开具用于企业报销的发票？',
          content: '如您开具的增值税普通发票用于企业报销，根据国家税务相关政策要求请填写纳税人识别号：如您的单位是非企业性质或您要求开具个人名义抬头，您可以选择“个人/非企业单位”的开票选项，则无需填写纳税人识别号。'
        },
        {
          text: '开票信息填错怎么办？',
          content: '如您开具的发票填错发票抬头信息需要修改，请及时联系客服或停车场工作人员处理。'
        },
        {
          text: '为什么有些订单查不到？',
          content: '如您订单支付方式为非微信支付，将无法在订单历史中查询，倘若如需开具需在订单完成后立即开具，否则无法开具。'
        },
        // {
        //   text: '电子邮箱填错怎么办？',
        //   content: '如您填错电子邮箱地址，可在开票历史中点击重新发送，输入新的电子邮箱地址，稍后会发到您的电子邮箱，请注意查收。'
        // },
        {
          text: '如有其它疑问，请联系客服',
          content: this.$enumObject.providerConfig[config.projectName].servicePhone
        }
      ]
    }
  },
  methods: {
    // 跳转
    linkComponents () {
      this.$toast('暂未开通 敬请期待！')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  .service {
    display: flex;
    justify-content: center;
    font-size: 16px;
    margin-top: 30px;
  }
  .whiteLine {
    background-color: #f5f5f5;
    height: 5px;
  }
  .header {
    height: 100px;
    padding: 0 15px 0;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-content: center;
    margin-bottom: 10px;
    &__question {
      font-size: 22px;
      font-family: SourceHanSansCN-Bold;
      font-weight: bold;
      line-height: 26px;
    }
    &__service {
      font-size: 14px;
      font-family: SourceHanSansCN-Bold;
      font-weight: bold;
      line-height: 18px;
      color: #999;
    }
  }
}
</style>
